module.exports = __webpack_public_path__ + "img/white-settings.842a1d09.svg";